module.exports = __webpack_public_path__ + "img/zhaohang4.934a83fc.png";